/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var Ladda = require('ladda');
var Radio = require('backbone.radio');

var BreadcrumbView = require('common/views/BreadcrumbView');

var CorpFinRecordHeaderBarView = require('../../common/views/CorpFinRecordHeaderBarView');
var CorpFinInvHistoryFormView = require('./CorpFinInvHistoryFormView');
var SubmitInvestmentHistory = require('../services/SubmitInvestmentHistory');

var tmplCorpFinInvHistoryEditView = require('../templates/CorpFinInvHistoryEditView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplCorpFinInvHistoryEditView,

  className: 'corp-fin-inv-history-edit-view container-fluid',

  ui: {
    invHistoryForm: '.inv-history-form-container',
    headerBar: '.header-bar',
    breadcrumb: '.breadcrumb-container',
    submit: '.submit'
  },

  regions: {
    invHistoryForm: '@ui.invHistoryForm',
    headerBar: '@ui.headerBar',
    breadcrumb: '@ui.breadcrumb'
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  onBeforeShow: function() {
    var record = this.model.get('record') || {};
    var recordId = this.model.get('recordId');
    var fileNumber = record.fileNumber;

    this.showChildView(
      'headerBar',
      new CorpFinRecordHeaderBarView({
        model: new Backbone.Model(record)
      })
    );

    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#corpfin/dashboard',
            text: 'Home'
          },
          {
            link: '#corpfin/investment/' + recordId + '/dashboard',
            text: 'Investment (' + fileNumber + ')'
          },
          {
            text: 'Edit Investment History'
          }
        ]
      })
    );

    this.invHistoryForm = new CorpFinInvHistoryFormView({
      model: this.model
    });

    this.showChildView('invHistoryForm', this.invHistoryForm);
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    this.validate().done(
      function() {
        var laddaContext = Ladda.create(this.ui.submit.get(0));
        laddaContext.start();
        var formData = this.getFormData();
        SubmitInvestmentHistory(formData)
          .done(function() {
            Radio.channel('navigate').trigger('show:int:cf:investment-dashboard', formData.recordId);
          })
          .fail(function() {
            laddaContext.stop();
          });
      }.bind(this)
    );
  },

  validate: function() {
    return this.ui.invHistoryForm.parsley().whenValidate();
  },

  getFormData: function() {
    var formData = this.invHistoryForm.getFormData();
    formData.investmentHistoryId = this.model.get('invHistoryId');
    formData.recordId = this.model.get('recordId');
    return formData;
  }
});
